var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIctoastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-Documents-uploadFile-ToastMessage",
    transform: "translate(-1185.000000, -822.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1185.000000, 822.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EB3D2F",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97680163,11.734 C10.5508016,11.734 10.6628016,11.328 10.6908016,10.838 L10.9428016,6.036 C10.9708016,5.364 10.9428016,5 10.3408016,5 L9.62680163,5 C9.02480163,5 8.96880163,5.364 9.01080163,6.036 L9.26280163,10.838 C9.29080163,11.328 9.40280163,11.734 9.97680163,11.734 Z M10.1588016,15.892 C10.6908016,15.892 10.9428016,15.626 10.9428016,15.094 L10.9428016,14.73 C10.9428016,14.198 10.6908016,13.932 10.1588016,13.932 L9.79480163,13.932 C9.26280163,13.932 9.01080163,14.198 9.01080163,14.73 L9.01080163,15.094 C9.01080163,15.626 9.26280163,15.892 9.79480163,15.892 L10.1588016,15.892 Z",
    id: "!",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIctoastError);
export default __webpack_public_path__ + "static/media/ictoastError.09e143c4097c4890922f4083ef8573ec.svg";
export { ForwardRef as ReactComponent };